module.exports = __webpack_public_path__ + "static/wikifolio-c6546becbd4e9af73c6b977ade57bf29.png";